// @ts-nocheck
const staffelInit = (staffel: HTMLElement) => {
  function between(x, min, max) {
    return x >= min && x <= max;
  }

  const staffelStepParent: HTMLElement | null = document.querySelector('.graduated-discount');
  const inputQuantity = document.querySelector('.quantity input[type="number"]');
  const staffelStep = staffelStepParent.dataset.step || 1;
  const addToCart = document.querySelector('.single_add_to_cart_button');
  const variations = document.querySelectorAll('span.product-options__option');

  const selectRow = () => {
    const staffelParent: HTMLElement | null = document.querySelector('.graduated-discount');
    const allRows = staffelParent.querySelectorAll('.wdr_bulk_table_msg--tapes tr');
    allRows.forEach((row) => {
      const fromQty = parseInt(row.dataset.qty, 10);
      const toQty = parseInt(row.dataset.max, 10);

      row.classList.remove('active');

      if ((
        toQty === 0 && parseInt(inputQuantity.value, 10) >= fromQty)
        || between(parseInt(inputQuantity.value, 10), fromQty, toQty)
      ) {
        row.classList.add('active');
      }
    });
  };

  // Function to adjust the step attribute of an input element
  const adjustStep = () => {
    // Parse the float value of the input element
    const value = parseFloat(inputQuantity.value);
    // Parse the integer value of the input element
    const intValue = parseInt(inputQuantity.value, 10);

    // If the parsed value is 1, set the step attribute to '5'
    if (value === 1) {
      inputQuantity.step = '5';
    } else if (intValue >= staffelStep) {
      // If the parsed integer value is greater than or equal to staffelStep

      // Set the step attribute to staffelStep
      inputQuantity.step = staffelStep;
      // Retrieve the old value from the dataset
      const oldValue = parseInt(inputQuantity.dataset.oldvalue, 10);
      // Calculate a new value based on the current value and staffelStep
      const newValue = Math[oldValue < value ? 'ceil' : 'floor'](value / staffelStep) * staffelStep;
      // Update the input value and the dataset with the new value
      inputQuantity.dataset.oldvalue = newValue.toString();
      inputQuantity.value = newValue;
    } else {
      // If the parsed integer value is less than staffelStep
      // Set the step attribute to '6'
      inputQuantity.step = '6';
    }
  };

  if (staffel.dataset.type === 'tapes') {
    inputQuantity.step = '6';
    inputQuantity.addEventListener('input', () => {
      adjustStep();
      selectRow();
    });

    addToCart.addEventListener('click', (e) => {
      inputQuantity.removeAttribute('step');
    });
  }

  const adjustPrice = (staffelParent) => {
    const quantityInput: HTMLInputElement = document.querySelector('.quantity input[type="number"]');
    const allRows = staffelParent.querySelectorAll('.wdr_bulk_table_msg--tapes tr');
    allRows.forEach((row) => {
      if (row.classList.contains('wdr_bulk_table_tr')) {
        const fromQty = parseInt(row.dataset.qty, 10);
        const toQty = parseInt(row.dataset.max, 10);
        const pricePerPiece = parseFloat(row.dataset.price);
        const priceDisplay = staffelParent.querySelector('.staffel-price-per-piece .priceSpan');
        const totalPriceDisplay = staffelParent.querySelector('.staffel-price-total .priceSpan');

        if ((
          toQty === 0 && parseInt(quantityInput.value, 10) >= fromQty)
          || between(parseInt(quantityInput.value, 10), fromQty, toQty)
        ) {
          const prices = pricePerPiece.toFixed(2).split('.');
          priceDisplay.innerHTML = `${prices[0]}, <span>${prices[1]}</span>`;

          const totalPrice = parseFloat(quantityInput.value) * pricePerPiece;
          totalPriceDisplay.innerHTML = totalPrice.toFixed(2).toString().replace('.', ',');
        } else if (parseInt(quantityInput.value, 10) < 6) {
          totalPriceDisplay.innerHTML = '0,00';
        }
      }
    });
  };

  const updateStaffelTable = (staffle: HTMLElement) => {
    const labels = JSON.parse(staffle.dataset.labels || '[]');

    setTimeout(() => {
      if (staffle.dataset.type === 'tapes') {
        const staffelParent: HTMLElement | null = document.querySelector('.graduated-discount');
        if (!staffelParent) return;

        const lowestPrice = staffelParent.querySelector('.lowestPrice')?.innerHTML;
        const fromPrice = staffelParent.querySelector('.fromPrice span.fromPrice__price');
        const quantityInput = document.querySelector('.quantity input[type="number"]');

        if (!quantityInput) return;

        if (variations) {
          variations.forEach((variation) => {
            if (variation.classList.contains('single-product-attr--active')) {
              const highestPrice = staffelParent.querySelector('.maxPrice__price');
              highestPrice.innerHTML = variation.dataset.price;
            }
          });
        }

        if (lowestPrice) {
          fromPrice?.innerHTML = lowestPrice;
        }
        const allRows = staffelParent.querySelectorAll('.wdr_bulk_table_msg--tapes tr');

        allRows.forEach((row) => {
          if (row.classList.contains('wdr_bulk_table_tr')) {
            row.addEventListener('click', () => {
              quantityInput.value = row.dataset.qty || '0';
              adjustStep();

              allRows.forEach((subrow) => {
                subrow.classList.remove('active');
              });
              row.classList.add('active');
              adjustPrice(staffelParent);
            });
          }
        });

        if (labels) {
          const labelWrappers = staffelParent.querySelectorAll('.staffel-extra-labels');
          let count = 1;

          labelWrappers.forEach((row) => {
            labels.forEach((label: any) => {
              if (count == label.staffelkorting_tapes_position) {
                const oldSpan = row.querySelector('.staffel-extra-labels');
                const span = document.createElement('span');
                span.innerHTML = label.staffelkorting_tapes_title;
                span.classList.add('staffel-extra-labels');
                span.classList.add(`staffel-extra-labels--${label.staffelkorting_tapes_color}`);

                if (span.innerHTML !== '' && oldSpan) {
                  row.replaceChild(span, oldSpan);
                } else {
                  row.appendChild(span);
                }
              }
            });
            count += 1;
          });
        }

        quantityInput.addEventListener('input', () => {
          adjustPrice(staffelParent);
        });
        staffelParent?.classList.remove('graduated-discount--loading');
      }
    }, 750);
  };

  const setStaffelTable = (staffle: HTMLElement | null) => {
    const staffelParent: HTMLElement | null = document.querySelector('.graduated-discount');
    const customStaffel: HTMLElement | null = document.querySelector('.graduated-discount-custom');
    const childStaffel: HTMLElement | null = staffelParent.querySelector('.awdr-bulk-customizable-table');

    if (!staffle) {
      staffelParent?.remove();
      return;
    }

    if (childStaffel) {
      childStaffel.remove();
    }

    const staffleTable: HTMLElement | null = staffle.querySelector('table');
    const cloneStaffle = staffle.cloneNode(true);

    if (staffleTable) {
      staffelParent?.append(cloneStaffle);

      if (customStaffel) {
        customStaffel?.classList.add('graduated-discount--show');
      } else {
        staffelParent?.classList.add('graduated-discount--show');

        if (staffle.dataset.type === 'tapes') {
          staffelParent?.classList.add('graduated-discount--loading');
        }
      }
    } else {
      staffelParent?.remove();
    }

    adjustPrice(staffelParent);

    setTimeout(() => {
      updateStaffelTable(staffel);
    }, 500);
  };

  setTimeout(() => {
    setStaffelTable(staffel);
    selectRow();
  }, 200);

  if (variations) {
    variations.forEach((variation) => {
      variation.addEventListener('click', () => {
        setStaffelTable(staffel);
      });
    });
  }
};

export default staffelInit;
